import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const modalRoot = document.getElementById("modal");

const Modal = ({ children, handleClick, onClose, title, className, show }) => {
  const elRef = useRef(null);
  const closeHandler = onClose || handleClick;

  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  useEffect(() => {
    if (modalRoot && elRef.current) {
      modalRoot.appendChild(elRef.current);
      return () => {
        if (modalRoot.contains(elRef.current)) {
          modalRoot.removeChild(elRef.current);
        }
      };
    }
  }, []);

  const content =
    show === false ? null : (
      <>
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={closeHandler}
          aria-hidden="true"
        />
        <div
        style={{
          minWidth: "60vw",
          maxHeight: "90vh",
          maxWidth: "80vw",
        }}
        className={` ${className} fixed overflow-x-auto overflow-y-auto z-50 bg-white shadow-xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`}
      >
        <div
          className={`font-bold p-2 min-w-full overflow-x-hidden bg-green-500 h-10 text-white rounded-t-lg sticky top-0 z-10`}
        >
          {title}
          <span>
            <button
              type="button"
              className="absolute top-0 right-0 font-bold p-2 px-5 hover:bg-red-500 text-red-50 rounded-tr-lg"
              onClick={closeHandler}
            >
              X
            </button>
          </span>
        </div>
        <div className="overflow-x-auto overflow-y-auto pb-0">
          {children}
        </div>
      </div>
    </>
    );

  return createPortal(content, elRef.current);
};

export default Modal;